import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { getCompany, setCompany, companyMeta, applyCompanyTheme } from "@/lib/company";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [company, setCompanyState] = useState(getCompany());

  useEffect(() => {
    applyCompanyTheme();
    // Returning from Google OAuth: let AuthCallback exchange the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data.company) {
          setCompany(r.data.company);
          setCompanyState(r.data.company);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password, comp = getCompany()) => {
    const { data } = await api.post("/auth/login", { username, password, company: comp });
    setCompany(data.user.company || comp);
    setCompanyState(data.user.company || comp);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    setCompany(data.user.company || getCompany());
    setCompanyState(data.user.company || getCompany());
    setUser(data.user);
    return data.user;
  };

  const switchCompany = async (comp) => {
    await api.post("/auth/switch-company", { company: comp });
    setCompany(comp);
    setCompanyState(comp);
    window.location.href = "/";
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("taf_company");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, loginWithGoogle, logout, company, switchCompany, meta: companyMeta(company), setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}
